export const deleteLabelCopy = {
  header: '',
  description: '',
  successToast: '',
  keepLabel: '',
};
